<template>
    <div class="static-content">
        <slot>
            <div v-if="content" v-html="content"></div>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'StaticContent',
    props: {
        content: {
            type: String,
            default: '',
        },
    },
};
</script>

<style lang="scss" src="./StaticContent.scss"></style>
